import { render, staticRenderFns } from "./TrainingSegmentCompany.vue?vue&type=template&id=13d23be4"
import script from "./TrainingSegmentCompany.vue?vue&type=script&lang=js"
export * from "./TrainingSegmentCompany.vue?vue&type=script&lang=js"
import style0 from "./TrainingSegmentCompany.vue?vue&type=style&index=0&id=13d23be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports